import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';

import { XmlResponse } from '../../../models/api-xml-2/xml-2/xml-2-response.model';

@Injectable({
  providedIn: 'root'
})
export class Xml2Service {
  
  pathUrl:string = environment.backend.pathUrl.store.import_xml;
  baseUrl:string = environment.backend.baseUrl_backend;
  url:string = this.baseUrl + this.pathUrl;

  constructor(
    private http: HttpClient
  ) { }

    /**Import
   * 
   * @param request 
   * @param file 
   * @returns Observable XmlResponse
   */
     import(file: File):Observable<XmlResponse>{
      let url = this.url;
      let headers = new HttpHeaders();
      headers.append('Content-Type', 'multipart/form-data');
      headers.append('Accept', 'application/json');
      const formData = new FormData();
      formData.append('file', file);
      return this.http.post<XmlResponse>(url,formData,{headers:headers});
    }
}
